module.exports = __webpack_public_path__ + "img/Close.7634175c.svg";